<div class="flex flex-col flex-auto p-8 xs:p-2 items-center">
  <div class="flex flex-wrap">
    <!-- Budget -->
    <div class="flex flex-auto w-1/3 min-w-80 p-4 lt-xl:w-full" *ngIf="accounts && accounts.length > 0">
      <div class="flex flex-col flex-auto p-6 bg-card rounded shadow-md">
        <div class="flex items-center">
          <div class="flex flex-col">
            <div class="font-bold text-md text-secondary uppercase tracking-wider">{{ accountsCount }} Workspaces</div>
          </div>
        </div>
        <div class="flex flex-col">
          <ng-container *ngFor="let account of accounts">
            <div class="flex items-center my-4">
              <div class="flex items-center justify-center w-14 h-14 rounded red-100">
                <img *ngIf="account.image_url" [src]="account.image_url" />
                <mat-icon [svgIcon]="'heroicons_outline:credit-card'" *ngIf="!account.image_url"> </mat-icon>
              </div>
              <div class="flex-auto ml-4 leading-none">
                <div class="font-semibold text-xs text-hint uppercase tracking-wider">
                  <ng-container *ngIf="!account.isCollaborator">
                    <a href="https://{{ account.subdomain }}.{{ appDomain }}/projects">{{ account.name }}</a>
                  </ng-container>
                  <ng-container *ngIf="account.isCollaborator">
                    <a href="https://{{ account.subdomain }}.{{ appDomain }}/tasks/global">{{ account.name }}</a>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              user &&
              (user.email === 'roger@termsheet.com' ||
                user.email === 'amol@termsheet.com' ||
                user.email === 'eric@termsheet.com' ||
                user.email === 'devin@termsheet.com' ||
                user.email === 'jasmine@termsheet.com')
            "
          >
            <div class="flex items-center my-4">
              <div class="flex items-center justify-center w-14 h-14 rounded red-100">
                <mat-icon [svgIcon]="'add'"></mat-icon>
              </div>
              <div class="flex-auto ml-4 leading-none">
                <div class="font-semibold text-xs text-hint uppercase tracking-wider">
                  <a (click)="showOnboardingModal()">New Account</a>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
